<nz-layout class="table-margin">
  @if (title) {
  <nz-header class="table-header">
    @if (isEOC() || isInpatientView() || isPreview || (data.length! > 0 || isLoading)) {
    <div class="table-header-row margin-lr">
      <div class="table-header-cell">
        {{ title | translate }}
        @if (
        !isLoading &&
        (isEOC() || isInpatientView() || isPreview) &&
        (this.dataGetList?.noKnown ||
        this.dataGetList?.noInfo ||
        (this.dataGetList?.noKnown == false &&
        this.dataGetList?.noInfo == false &&
        this.dataGetList?.getAll == null &&
        this.dataGetList?.getUnknown == null))
        ) {
        <span class="margin-llr">
          <div class="no-known-content">
            <nz-switch [ngModel]="this.dataGetList?.noKnown" [nzDisabled]="
                !hasPermission(addPermissions) ||
                this.dataGetList?.isSubmitted ||
                isPreview
              " [nzLoading]="isNoKnownLoading"></nz-switch>
            <div>{{ "No known" | translate }}</div>
            <div class="add-title">&nbsp;</div>
            <div class="add-title">{{ title | translate }}</div>
          </div>
        </span>
        }
      </div>
      <div class="table-header-cell margin-lrr" *hasAddPermissions="addPermissions">
        @if ((isEOC() || isInpatientView()) && !isPreview) {
        <button nz-button nzShape="round" (click)="openModal()">
          <div fxLayout="row">
            <div fxLayout="col">
              <mat-icon class="add-icon">add_circle_outline</mat-icon>
            </div>
            <div fxLayout="col" class="add-title">
              {{ "Add" | translate }} {{ title | translate }}
            </div>
          </div>
        </button>
        }
      </div>
    </div>
    }
    @if (
    !(isEOC() || isInpatientView()) && !isPreview && !(data.length! > 0)
    ) {
    <div fxLayout="row" class="table-header-row">
      @if (!isLoading) {
      <div fxLayout="col" class="title">
        {{ title | translate }} - {{ getUnknownText() | translate }}
      </div>
      }
    </div>
    }
  </nz-header>
  }
  @if (
  ((data.length! > 0 && !this.dataGetList?.noKnown) || isLoading) &&
  !isNoKnownLoading
  ) {
  <nz-content>
    <nz-table #nzTable nzTableLayout="fixed" nzShowTitle="false" nzSize="middle"
      nzNoResult="{{ getUnknownText() | translate }}" [nzLoading]="isLoading" [nzData]="data || []"
      [nzShowPagination]="pagination" [nzShowSizeChanger]="pagination" nzPaginationType="default"
      [nzFrontPagination]="pagination" [nzPageIndex]="currentPageIndex"
      (nzPageIndexChange)="handlePageIndexChange($event)" (nzPageSizeChange)="handlePageSizeChange($event)"
      [nzPageSizeOptions]="[5, 10]" [nzPageSize]="pageSize">
      <thead>
        <tr>
          <th class="bold">{{ title | translate }}</th>
          @for (item of filteredData; track item; let i = $index) {
          <th class="bold"
            [ngClass]="{'draft-entry': !item?.['isSubmitted'], 'first-draft-entry': !item?.['isSubmitted'] && i === 0}">
            {{ getValue(colIdentifier, item.date) | translate }}
            @if (
            (isEOC() || isInpatientView()) &&
            !item['isSubmitted'] &&
            !isPreview
            ) {
            <span class="actions">
              <i nz-icon nzType="icons:delete" nzTheme="outline" class="delete-btn"
                (click)="deleteFun(item.id!); $event.stopPropagation()"></i>
              <i nz-icon nzType="icons:form" nzTheme="outline" class="edit-btn"
                (click)="openModal(item); $event.stopPropagation()"></i>
            </span>
            }
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (field of columnIDs; track field; let i = $index) {
        <tr>
          <td class="bold">
            {{ rowNames[i] }}
            <app-tooltip [fieldName]="findField(field)" [area]="title" />
          </td>
          @for (item of filteredData; track item) {
          <td [ngClass]="{'draft-entry-item': !item?.['isSubmitted']}">
            @if (
            getValue(
            findField(field),
            findValue(field, item.items!)
            ); as value
            ) {
            <span>
              {{ value }}
            </span>
            }
          </td>
          }
        </tr>
        }
      </tbody>
    </nz-table>
  </nz-content>
  }
</nz-layout>

<!-- MODAL -->
<nz-modal #modalRef nzSize [(nzVisible)]="isVisible" [nzTitle]="(isEdit ? 'Edit ' : 'Add ') + title | translate"
  (nzOnCancel)="handleCancel()" nzCancelText="Cancel" nzOkText="Save" nzOkType="primary" [nzFooter]="null"
  class="custom-modal-class">
  <ng-container *nzModalContent>
    <form [formGroup]="tableForm" (ngSubmit)="submitForm()" [ngClass]="{
        'item-submitted': itemSubmitted,
        'item-not-submitted': !itemSubmitted
      }">
      @for (inp of dropdownData; track inp) {
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ inp.name | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          @if (inp.type == 'number') {
          <input nz-input class="inputs item" type="number" [placeholder]="inp.name + '...' | translate"
            [formControlName]="inp.name.replace(' ', '')" [min]="
                inp?.minValue == undefined || inp?.minValue == null
                  ? null
                  : inp?.minValue!
              " [max]="
                inp?.maxValue == undefined || inp?.maxValue == null
                  ? null
                  : inp?.maxValue!
              " />
          }
          @if (inp.type == 'string') {
          <input nz-input class="inputs item" type="text" [placeholder]="inp.name + '...' | translate"
            [formControlName]="inp.name.replace(' ', '')" />
          }
        </div>
      </div>
      }

      <div fxLayout="row" fxLayoutAlign="end" class="footer">
        <button nz-button nzPrimary class="save-btn" type="submit" [nzLoading]="isLoading" [disabled]="isLoading">
          {{ "Save" | translate }}
        </button>
        <button nz-button nzDanger class="cancel-btn" type="button" (click)="handleCancel()" [disabled]="isLoading">
          {{ "Cancel" | translate }}
        </button>
      </div>
    </form>
  </ng-container>
</nz-modal>